/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface PaginationMetaDto
 */
export interface PaginationMetaDto {

    /**
     * Total number of records matching the query
     *
     * @type {number}
     * @memberof PaginationMetaDto
     * @example 100
     */
    total: number;

    /**
     * Current page number (1-based)
     *
     * @type {number}
     * @memberof PaginationMetaDto
     * @example 1
     */
    page: number;

    /**
     * Maximum records returned per page
     *
     * @type {number}
     * @memberof PaginationMetaDto
     * @example 10
     */
    limit: number;

    /**
     * Total number of pages
     *
     * @type {number}
     * @memberof PaginationMetaDto
     * @example 10
     */
    pages: number;
}
